'use client';

import { createContext, useContext } from 'react';

export const BottomContainerContext = createContext<{
   hasBottomSheet: boolean;
   setHasBottomSheet: (value: boolean) => void;
}>({
   hasBottomSheet: false,
   setHasBottomSheet: () => {}
});

export const useBottomContainerContext = () => {
   const context = useContext(BottomContainerContext);
   if (!context) {
      throw new Error('useRequestForQuotationContext must be used within a RequestForQuotationContextProvider');
   }
   return context;
};
